import { DownloadOutlined } from "@ant-design/icons";
import {
  Button,
  Table,
  Tooltip,
  Typography,
} from "antd";
import { useEffect } from "react";
import { billingService } from "@/services";
import { useObservable } from "@/utils/use-observable";
import "./index.less";
import { renderCurrency, renderDateTime, renderStatus } from "@/utils";
import { internalInternalInvoiceStatusList } from "@/models/enum/intenral-invoice-status";
import { InternalInvoice } from "@/models/internal-invoice";
import { BillingPreviewCards } from "./billing-preview-cards";
import { exportInternalInvoiceItemsCsv } from "./export-internal-invoice-items-csv";
import { InternalInvoiceItemsTable } from "./internal-invoice-items-table";

const { Title } = Typography;

export default function InternalInvoicesPage() {
  const columns = [
    {
      title: "Date",
      key: "date",
      dataIndex: "date",
      width: 150,
      render: renderDateTime,
    },
    {
      title: "Reference",
      key: "yearMonth",
      dataIndex: "yearMonth",
      width: 100
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      width: 100,
      render: renderStatus(internalInternalInvoiceStatusList)
    },
    {
      title: "Recovered Amount",
      key: "recoveredAmount",
      dataIndex: "recoveredAmount",
      width: 150,
      render: renderCurrency,
    },
    {
      title: "Amount",
      key: "amount",
      dataIndex: "amount",
      width: 150,
      render: renderCurrency,
    },
    {
      title: "",
      key: "export",
      width: 32,
      align: "center" as const,
      className: "export-column",
      render: (_: unknown, record: InternalInvoice) => (
        <Tooltip title="Export details">
          <Button
            shape="circle"
            size="small"
            icon={<DownloadOutlined />}
            disabled={!record.items?.length}
            onClick={() =>
              exportInternalInvoiceItemsCsv(
                record.items,
                `billing-${record.year}-${String(record.month).padStart(2, "0")}-details.csv`
              )
            }
          />
        </Tooltip>
      ),
    },
  ];

  const invoices = useObservable(billingService.invoices);
  const preview = useObservable(billingService.preview);

  useEffect(() => {
    billingService.getPreview();
    billingService.getInvoices();
  }, []);

  const expandedRowRender = (record: InternalInvoice) => {
    return (
      <div className="expanded-row-block">
        <InternalInvoiceDetails
          invoice={record}
        />
      </div>
    );
  };

  return (
    <div className="internal-invoices-page">
      <BillingPreviewCards preview={preview} />
      <Title level={3}>Billing</Title>
      <Table
        columns={columns}
        dataSource={invoices}
        expandable={{ expandedRowRender }}
        rowKey="id"
        size="small"
        pagination={{ position: ["bottomCenter"] }}
        scroll={{ x: 1000 }}
      />
    </div>
  );
}

function InternalInvoiceDetails(props: { invoice: InternalInvoice }) {
  return <InternalInvoiceItemsTable items={props.invoice.items} title="Details" />;
}
